export default __webpack_public_path__ + "static/yoga-6-7051f971faa0aa57be336a4c533985d5.png";